(() => {
  const roots = document.querySelectorAll('[data-compare-page]');
  roots.forEach((root) => {
    let products = [];
    let modelProducts = [];
    let series = [];
    let finder = { enabled: false, root: '', questions: [], configured: false, requestedEnabled: false };
    let finderParseError = false;
    try { products = JSON.parse(root.querySelector('[data-compare-products]')?.textContent || '[]'); } catch (error) { products = []; }
    try { series = JSON.parse(root.querySelector('[data-compare-series]')?.textContent || '[]'); } catch (error) { series = []; }
    try { finder = JSON.parse(root.querySelector('[data-finder-config]')?.textContent || '{}'); } catch (error) { finderParseError = true; }

    try { modelProducts = JSON.parse(root.querySelector('[data-compare-model-products]')?.textContent || '[]'); } catch (error) { modelProducts = []; }
    const byId = new Map([...modelProducts, ...products].map((product) => [String(product.id), product]));
    const modelIdSet = new Set(modelProducts.map((product) => String(product.id)));
    const pathButtons = [...root.querySelectorAll('[data-compare-path]')];
    const flows = [...root.querySelectorAll('[data-compare-flow]')];
    const modeButtons = [...root.querySelectorAll('[data-compare-mode]')];
    const seriesPanel = root.querySelector('[data-series-panel]');
    const individualPanel = root.querySelector('[data-individual-panel]');
    const seriesDescription = root.querySelector('[data-series-description]');
    const seriesTabs = [...root.querySelectorAll('[data-series-key]')];
    const title = root.querySelector('[data-compare-title]');
    const selectionCount = root.querySelector('[data-selection-count]');
    const structure = root.querySelector('[data-compare-structure]');
    const emptyState = root.querySelector('[data-compare-empty]');
    const table = root.querySelector('[data-compare-table]');
    const scrollControls = root.querySelector('[data-compare-scroll]');
    const scrollPrevious = root.querySelector('[data-scroll-previous]');
    const scrollNext = root.querySelector('[data-scroll-next]');
    const modelEmptyText = emptyState.textContent.trim();
    const updateScroll = () => {
      const maximum = table.scrollWidth - table.clientWidth;
      scrollControls.hidden = table.hidden || table.clientWidth === 0 || maximum <= 1;
      scrollPrevious.disabled = table.scrollLeft <= 1;
      scrollNext.disabled = table.scrollLeft >= maximum - 1;
    };
    const scrollColumn = (direction) => {
      const width = table.querySelector('.compare-row--head .compare-cell:nth-child(2)')?.getBoundingClientRect().width || 240;
      table.scrollBy({ left: direction * width, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    scrollPrevious.addEventListener('click', () => scrollColumn(-1));
    scrollNext.addEventListener('click', () => scrollColumn(1));
    table.addEventListener('scroll', updateScroll, { passive: true });
    new ResizeObserver(updateScroll).observe(table);
    const differences = root.querySelector('[data-differences-toggle]');
    const drawer = root.querySelector('[data-model-drawer]');
    const drawerOpen = root.querySelector('[data-drawer-open]');
    const drawerDone = root.querySelector('[data-drawer-done]');
    const drawerGrid = root.querySelector('[data-model-grid]');
    const drawerCount = root.querySelector('[data-drawer-count]');
    const selectedList = root.querySelector('[data-selected-list]');
    let mode = 'series';
    let activeSeries = null;
    let seriesProducts = [];
    let selected = [];
    let modelSelection = [];
    let showDifferences = false;
    let lastFocus = null;

    const list = (value) => Array.isArray(value) ? value : String(value || '').split(',').map((item) => item.trim()).filter(Boolean);
    const getProduct = (id) => byId.get(String(id));
    const setSelected = (ids) => {
      selected = [...new Set(ids.map(String))].map(getProduct).filter(Boolean);
      if (mode === 'individual') {
        selected = modelsReady ? selected.filter((product) => modelIdSet.has(String(product.id))) : [];
        selected = selected.slice(0, 3);
        modelSelection = selected.map((product) => product.id);
      } else if (activeSeries) {
        selected = seriesProducts;
      }
      renderSelected();
      renderModelGrid();
      renderComparison();
    };
    const renderSelected = () => {
      selectedList.hidden = mode !== 'individual' || selected.length === 0;
      selectedList.replaceChildren();
      if (mode === 'individual') selected.forEach((product) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'compare-chip';
        chip.textContent = `${product.title} ×`;
        chip.setAttribute('aria-label', selectedList.dataset.removeLabel.replace('__title__', product.title));
        chip.addEventListener('click', () => {
          setSelected(selected.filter((item) => String(item.id) !== String(product.id)).map((item) => item.id));
          (selectedList.querySelector('button') || drawerDone).focus();
        });
        selectedList.append(chip);
      });
      drawerCount.textContent = drawerCount.dataset.countTemplate.replace('__count__', modelSelection.length);
      selectionCount.textContent = mode === 'series' ? messages.compared.replace('__count__', selected.length) : drawerCount.textContent;
    };
    const categories = root.querySelector('[data-model-categories]');
    const modelTitle = root.querySelector('[data-model-title]');
    const notice = root.querySelector('[data-model-notice]');
    const retry = root.querySelector('[data-model-retry]');
    const modelData = root.querySelector('[data-compare-model-products]');
    const messages = JSON.parse(root.querySelector('[data-compare-messages]').textContent);
    let activeCategory = '';
    let modelsReady = false;
    let loading = false;
    let loadError = false;
    const seriesKey = (product) => String(product?.series || '').trim();
    const groupKeys = () => [...new Set(modelProducts.map(seriesKey).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
    const renderModelGrid = () => {
      const focusedId = drawerGrid.contains(document.activeElement) ? document.activeElement.dataset.modelId : null;
      const ids = new Set(modelSelection.map(String));
      notice.textContent = loading ? messages.loading : loadError ? messages.error : !modelProducts.length ? messages.empty : '';
      notice.hidden = !notice.textContent;
      retry.hidden = !loadError;
      drawerGrid.setAttribute('aria-busy', String(loading));
      categories.querySelectorAll('button').forEach((button) => {
        const active = button.dataset.modelSeries === activeCategory;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
        if (active) modelTitle.parentElement.setAttribute('aria-labelledby', button.id);
      });
      modelTitle.textContent = activeCategory;
      drawerGrid.replaceChildren();
      if (!modelsReady) return;
      modelProducts.filter((product) => seriesKey(product) === activeCategory).forEach((product) => {
        const button = document.createElement('button');
        const chosen = ids.has(String(product.id));
        button.type = 'button';
        button.className = 'compare-model-option';
        button.dataset.modelId = String(product.id);
        button.textContent = product.title;
        button.classList.toggle('is-selected', chosen);
        button.setAttribute('aria-pressed', String(chosen));
        button.disabled = !chosen && ids.size >= 3;
        button.addEventListener('click', () => {
          if (mode !== 'individual' || button.disabled) return;
          const next = modelSelection.map(String).filter((id) => id !== String(product.id));
          if (!chosen) next.push(String(product.id));
          setSelected(next);
        });
        drawerGrid.append(button);
        if (focusedId === String(product.id)) button.focus({ preventScroll: true });
      });
    };
    const activateCategory = (key) => {
      activeCategory = key;
      renderModelGrid();
      drawer.querySelector('.compare-drawer__body').scrollTop = 0;
    };
    const renderCategories = () => {
      const keys = groupKeys();
      if (!keys.includes(activeCategory)) activeCategory = keys[0] || '';
      categories.replaceChildren();
      keys.forEach((key, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'compare-model-category';
        button.dataset.modelSeries = key;
        button.id = `${drawer.id}-series-${index}`;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', modelTitle.parentElement.id);
        button.textContent = key;
        button.addEventListener('click', () => activateCategory(key));
        button.addEventListener('focus', () => activateCategory(key));
        button.addEventListener('pointerenter', () => {
          if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) activateCategory(key);
        });
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const step = ['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1;
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? keys.length - 1 : (index + step + keys.length) % keys.length;
          categories.children[next].focus();
        });
        categories.append(button);
      });
      renderModelGrid();
    };
    const loadModels = async () => {
      if (loading || modelsReady) return;
      loading = true;
      loadError = false;
      renderModelGrid();
      try {
        const merged = new Map();
        const addPage = (element) => {
          if (!element) throw new Error('Missing model data');
          const page = JSON.parse(element.textContent);
          if (!Array.isArray(page)) throw new Error('Invalid model data');
          page.forEach((product) => {
            if (product.id != null && seriesKey(product)) merged.set(String(product.id), product);
          });
          return element.dataset.nextPage || '';
        };
        let next = addPage(modelData);
        const visited = new Set();
        while (next) {
          const url = new URL(next, window.location.href);
          if (url.origin !== window.location.origin || visited.has(url.href)) throw new Error('Invalid pagination');
          visited.add(url.href);
          url.searchParams.set('section_id', root.dataset.comparePage);
          const response = await fetch(url.href, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
          if (!response.ok) throw new Error('Unable to load model page');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const pageRoot = [...document.querySelectorAll('[data-compare-page]')].find((element) => element.dataset.comparePage === root.dataset.comparePage);
          next = addPage(pageRoot?.querySelector('[data-compare-model-products]'));
        }
        modelProducts = [...merged.values()];
        modelIdSet.clear();
        modelProducts.forEach((product) => { modelIdSet.add(String(product.id)); byId.set(String(product.id), product); });
        modelsReady = true;
      } catch (error) {
        loadError = true;
        modelProducts = [];
      } finally {
        loading = false;
        renderCategories();
      }
    };
    retry.addEventListener('click', loadModels);
    const openDrawer = () => {
      if (mode !== 'individual') return;
      lastFocus = drawerOpen;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      drawerOpen.setAttribute('aria-expanded', 'true');
      renderModelGrid();
      (categories.querySelector('.is-active') || (loadError ? retry : drawerDone)).focus({ preventScroll: true });
    };
    const closeDrawer = (restoreFocus = true) => {
      if (drawer.hidden) return;
      const focusInside = drawer.contains(document.activeElement);
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      drawerOpen.setAttribute('aria-expanded', 'false');
      if (restoreFocus || focusInside) lastFocus?.focus({ preventScroll: true });
    };
    drawerOpen.addEventListener('click', () => drawer.hidden ? openDrawer() : closeDrawer());
    drawerDone.addEventListener('click', () => closeDrawer());
    document.addEventListener('click', (event) => {
      const path = event.composedPath();
      if (!drawer.hidden && !path.includes(drawer) && !path.includes(drawerOpen)) closeDrawer(false);
    });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !drawer.hidden) closeDrawer(); });

    const activateSeries = (key) => {
      activeSeries = series.find((item) => item.key === key) || null;
      seriesTabs.forEach((tab) => { const active = tab.dataset.seriesKey === key; tab.classList.toggle('is-active', active); tab.setAttribute('aria-selected', String(active)); });
      if (!activeSeries) return;
      seriesDescription.textContent = activeSeries.description || '';
      seriesProducts = [...new Set(activeSeries.products.map(String))].map(getProduct).filter(Boolean);
      setSelected(seriesProducts.map((product) => product.id));
      table.scrollLeft = 0;
      updateScroll();
      title.textContent = activeSeries.title;
    };
    seriesTabs.forEach((tab) => tab.addEventListener('click', () => activateSeries(tab.dataset.seriesKey)));

    const renderComparison = () => {
      structure.hidden = false;
      const ready = selected.length >= (mode === 'series' ? 1 : 2);
      emptyState.textContent = mode === 'series' ? emptyState.dataset.seriesEmpty : modelEmptyText;
      emptyState.hidden = ready;
      table.hidden = !ready;
      differences.disabled = selected.length < 2;
      if (differences.disabled) { differences.checked = false; showDifferences = false; }
      if (!ready) { table.innerHTML = ''; updateScroll(); return; }
      const fieldMap = new Map();
      selected.forEach((product) => (product.specs || []).forEach((spec) => { if (!fieldMap.has(spec.key)) fieldMap.set(spec.key, { label: spec.label, values: [] }); }));
      const fields = [...fieldMap.entries()].map(([key, field]) => ({ key, label: field.label })).filter((field) => {
        if (!showDifferences) return true;
        const values = selected.map((product) => (product.specs || []).find((spec) => spec.key === field.key)?.value || '').map((value) => String(value).trim().replace(/\s+/g, ' ').toLowerCase());
        return values.some((value) => !value) || new Set(values).size > 1;
      });
      table.style.setProperty('--compare-products', selected.length);
      requestAnimationFrame(updateScroll);
      table.dataset.modelCount = String(selected.length);
      const cell = (value, className = '') => {
        const element = document.createElement('div');
        element.className = `compare-cell ${className}`.trim();
        element.textContent = value;
        return element;
      };
      table.replaceChildren();
      const header = document.createElement('div');
      header.className = 'compare-row compare-row--head';
      const corner = cell('', 'compare-cell--label');
      corner.setAttribute('aria-hidden', 'true');
      header.append(corner);
      selected.forEach((product) => {
        const column = cell('');
        const name = document.createElement('strong');
        name.className = 'compare-model-name';
        name.textContent = product.title;
        column.append(name);
        header.append(column);
      });
      table.append(header);
      fields.forEach((field) => {
        const row = document.createElement('div');
        row.className = 'compare-row';
        row.append(cell(field.label, 'compare-cell--label'));
        selected.forEach((product) => row.append(cell((product.specs || []).find((spec) => spec.key === field.key)?.value || '—')));
        table.append(row);
      });
      if (!fields.length) {
        const message = document.createElement('p');
        message.className = 'compare-table-message';
        message.textContent = fieldMap.size ? messages.noDifferences : messages.noSpecs;
        table.append(message);
      }
      differences.disabled = selected.length < 2 || fieldMap.size === 0;
      if (differences.disabled) { differences.checked = false; showDifferences = false; }
    };
    differences?.addEventListener('change', () => { showDifferences = differences.checked; renderComparison(); requestAnimationFrame(updateScroll); });
    modeButtons.forEach((button) => button.addEventListener('click', () => {
      closeDrawer(false);
      mode = button.dataset.compareMode;
      modeButtons.forEach((item) => { const active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); });
      seriesPanel.hidden = mode !== 'series';
      individualPanel.hidden = mode !== 'individual';
      if (mode === 'individual') {
        setSelected(modelSelection);
        title.textContent = drawerOpen.querySelector('strong').textContent;
        renderModelGrid();
      } else if (activeSeries) {
        activateSeries(activeSeries.key);
      } else {
        setSelected([]);
      }
      table.scrollLeft = 0;
      requestAnimationFrame(updateScroll);
    }));
    pathButtons.forEach((button) => button.addEventListener('click', () => { closeDrawer(false); pathButtons.forEach((item) => { const active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); }); flows.forEach((flow) => { flow.hidden = flow.dataset.compareFlow !== button.dataset.comparePath; }); }));

    const initializeFinder = () => {
      const finderPath = pathButtons.find((button) => button.dataset.comparePath === 'finder');
      const finderFlow = flows.find((flow) => flow.dataset.compareFlow === 'finder');
      const hideFinder = (errors = []) => {
        if (finderPath) finderPath.hidden = true;
        if (finderFlow) finderFlow.hidden = true;
        if (finderPath?.classList.contains('is-active')) {
          const fallback = pathButtons.find((button) => button !== finderPath && !button.hidden);
          if (fallback) fallback.click();
        }
        if (errors.length) console.warn(`[Compare finder] ${errors.join(' ')}`);
      };
      if (finderParseError) { hideFinder(['Finder data is invalid JSON.']); return; }
      if (!finder.enabled) {
        const incomplete = finder.configured && finder.requestedEnabled;
        hideFinder(incomplete ? ['Selected finder is missing its root question or question list.'] : []);
        return;
      }

      const finderPanel = root.querySelector('[data-finder-panel]');
      const finderQuestion = root.querySelector('[data-finder-question]');
      const finderResult = root.querySelector('[data-finder-result]');
      const finderProgress = root.querySelector('[data-finder-progress]');
      const finderBar = root.querySelector('[data-finder-progress-bar]');
      const finderTrack = root.querySelector('[data-finder-progress-track]');
      const finderHistory = root.querySelector('[data-finder-history]');
      const finderLabel = root.querySelector('[data-finder-label]');
      const finderTitle = root.querySelector('[data-finder-title]');
      const finderAnswerList = root.querySelector('[data-finder-answers]');
      const finderBack = root.querySelector('[data-finder-back]');
      const finderResultBack = root.querySelector('[data-finder-result-back]');
      const finderRestart = root.querySelector('[data-finder-restart]');
      const finderName = root.querySelector('[data-finder-result-name]');
      const finderReason = root.querySelector('[data-finder-result-reason]');
      const finderPrice = root.querySelector('[data-finder-result-price]');
      const finderSpecifications = root.querySelector('[data-finder-specifications]');
      const finderSpecs = root.querySelector('[data-finder-specs]');
      const messageData = root.querySelector('[data-finder-messages]');
      const elements = [finderPath, finderFlow, finderPanel, finderQuestion, finderResult, finderProgress, finderBar, finderTrack, finderHistory, finderLabel, finderTitle, finderAnswerList, finderBack, finderResultBack, finderRestart, finderName, finderReason, finderPrice, finderSpecifications, finderSpecs, messageData];
      if (elements.some((element) => !element)) { hideFinder(['Finder data or markup is missing.']); return; }

      let finderText = {};
      try { finderText = JSON.parse(messageData.textContent); } catch (error) { hideFinder(['Finder messages are invalid.']); return; }
      const questions = Array.isArray(finder.questions) ? finder.questions : [];
      const questionMap = new Map();
      const questionKeys = new Set();
      const errors = [];
      questions.forEach((question) => {
        const id = String(question?.id || '');
        const key = String(question?.key || '');
        if (!id) errors.push('A question is missing its system ID.');
        else if (questionMap.has(id)) errors.push(`Duplicate question ID: ${id}.`);
        else questionMap.set(id, question);
        if (key && questionKeys.has(key)) errors.push(`Duplicate question key: ${key}.`);
        else if (key) questionKeys.add(key);
      });
      const rootId = String(finder.root || '');
      if (!questionMap.has(rootId)) errors.push('The root question is missing.');
      questions.forEach((question) => {
        const id = String(question?.id || '');
        if (!Array.isArray(question?.choices) || !question.choices.length) {
          errors.push(`Question ${question?.key || id || '(unknown)'} has no choices.`);
          return;
        }
        question.choices.forEach((choice) => {
          const next = String(choice?.next || '');
          const hasNext = Boolean(next);
          const hasProducts = choice?.hasProductTarget === true;
          if (hasNext === hasProducts) errors.push(`A choice in ${question.key || id} must have exactly one target.`);
          if (hasNext && !questionMap.has(next)) errors.push(`A choice in ${question.key || id} points to a missing question.`);
        });
      });
      const visiting = new Set();
      const visited = new Set();
      const visit = (id) => {
        if (visiting.has(id)) { errors.push(`Cycle detected at ${questionMap.get(id)?.key || id}.`); return; }
        if (visited.has(id) || !questionMap.has(id)) return;
        visiting.add(id);
        (questionMap.get(id).choices || []).forEach((choice) => { if (choice.next) visit(String(choice.next)); });
        visiting.delete(id);
        visited.add(id);
      };
      questions.forEach((question) => visit(String(question?.id || '')));
      const reachable = new Set();
      const markReachable = (id) => {
        if (reachable.has(id) || !questionMap.has(id)) return;
        reachable.add(id);
        (questionMap.get(id).choices || []).forEach((choice) => { if (choice.next) markReachable(String(choice.next)); });
      };
      markReachable(rootId);
      questions.forEach((question) => {
        const id = String(question?.id || '');
        if (id && !reachable.has(id)) errors.push(`Question ${question.key || id} is unreachable.`);
      });
      if (errors.length) { hideFinder([finderText.invalidConfig || 'Invalid configuration.', ...errors]); return; }

      let currentId = rootId;
      let history = [];
      let fallbackQueue = [];
      let fallbackCandidates = [];
      const finderElement = (tag, className, text = '') => {
        const element = document.createElement(tag);
        element.className = className;
        element.textContent = text;
        return element;
      };
      const uniqueProducts = (items) => {
        const unique = new Map();
        items.filter((product) => product && product.available !== false).forEach((product) => {
          const key = String(product.id || product.url || product.title || '');
          if (key && !unique.has(key)) unique.set(key, product);
        });
        return [...unique.values()];
      };
      const candidateProducts = (id, seen = new Set()) => {
        if (seen.has(id) || !questionMap.has(id)) return [];
        seen.add(id);
        return questionMap.get(id).choices.flatMap((choice) => choice.next
          ? candidateProducts(String(choice.next), new Set(seen))
          : choice.products || []);
      };
      const terminalQuestions = (id, seen = new Set()) => {
        if (seen.has(id) || !questionMap.has(id)) return [];
        seen.add(id);
        const question = questionMap.get(id);
        if (question.choices.every((choice) => !choice.next)) return [id];
        const terminals = question.choices.flatMap((choice) => choice.next
          ? terminalQuestions(String(choice.next), new Set(seen))
          : []);
        return [...new Set(terminals)];
      };
      const renderFinderSpecs = (recommended) => {
        finderSpecs.replaceChildren();
        finderSpecifications.hidden = recommended.length === 0;
        if (!recommended.length) return;
        const fields = new Map();
        recommended.forEach((product) => (product.specs || []).forEach((spec) => { if (!fields.has(spec.key)) fields.set(spec.key, spec.label); }));
        const wrap = finderElement('div', 'finder-spec-compare-wrap');
        wrap.tabIndex = 0;
        wrap.setAttribute('role', 'region');
        wrap.setAttribute('aria-label', finderText.specification);
        const grid = finderElement('div', 'finder-spec-compare');
        grid.style.setProperty('--finder-products', recommended.length);
        const head = finderElement('div', 'finder-spec-compare-row finder-spec-compare-head');
        head.append(finderElement('div', 'finder-spec-compare-cell finder-spec-compare-label', finderText.specification));
        recommended.forEach((product) => {
          const cell = finderElement('div', 'finder-spec-compare-cell');
          const link = finderElement('a', 'finder-spec-product-link', product.title);
          link.href = product.url;
          cell.append(link, finderElement('small', 'finder-spec-product-price', product.price || ''));
          head.append(cell);
        });
        grid.append(head);
        fields.forEach((label, key) => {
          const row = finderElement('div', 'finder-spec-compare-row');
          row.append(finderElement('div', 'finder-spec-compare-cell finder-spec-compare-label', label));
          recommended.forEach((product) => row.append(finderElement('div', 'finder-spec-compare-cell', (product.specs || []).find((spec) => spec.key === key)?.value || '—')));
          grid.append(row);
        });
        wrap.append(grid);
        finderSpecs.append(wrap);
        if (!fields.size) finderSpecs.append(finderElement('p', 'finder-spec-empty', finderText.noSpecs));
      };
      const renderHistory = () => {
        finderHistory.replaceChildren();
        history.forEach((entry) => {
          const questionData = questionMap.get(entry.questionId);
          const row = finderElement('div', 'finder-history-item');
          const question = finderElement('div', 'finder-history-question');
          question.append(finderElement('b', '', questionData.label || questionData.key), finderElement('span', '', questionData.title));
          row.append(question, finderElement('span', 'finder-history-answer', entry.answer));
          finderHistory.append(row);
        });
      };
      const showResult = (items, reason, focus = true) => {
        const recommended = uniqueProducts(items).slice(0, 3);
        finderQuestion.hidden = true;
        finderResult.hidden = false;
        finderResult.classList.remove('is-pending');
        finderProgress.textContent = finderText.recommendation;
        finderBar.style.width = '100%';
        finderTrack.setAttribute('aria-valuenow', '100');
        finderName.textContent = recommended.length === 1 ? recommended[0].title : recommended.length ? finderText.matching.replace('__count__', recommended.length) : finderText.empty;
        finderReason.textContent = recommended.length ? reason || finderText.reason : finderText.noResultsReason;
        finderPrice.textContent = recommended.length === 1 ? recommended[0].price || '' : recommended.length ? finderText.options.replace('__count__', recommended.length) : '';
        finderResultBack.hidden = history.length === 0;
        finderResultBack.textContent = finderText.back.replace('__number__', history.length);
        renderFinderSpecs(recommended);
        if (focus) finderName.focus({ preventScroll: true });
      };
      const renderQuestion = (focus = false) => {
        const question = questionMap.get(currentId);
        renderHistory();
        finderQuestion.hidden = false;
        finderResult.hidden = false;
        finderResult.classList.add('is-pending');
        finderProgress.textContent = finderText.question.replace('__number__', history.length + 1);
        const percent = Math.min(92, 14 + history.length * 19);
        finderBar.style.width = `${percent}%`;
        finderTrack.setAttribute('aria-valuenow', String(percent));
        finderBack.hidden = history.length === 0;
        finderBack.textContent = finderText.back.replace('__number__', history.length);
        finderResultBack.hidden = true;
        finderName.textContent = finderText.pendingTitle;
        finderReason.textContent = finderText.pendingReason;
        finderPrice.textContent = '';
        finderSpecifications.hidden = true;
        finderSpecs.replaceChildren();
        finderLabel.textContent = question.label || question.key;
        finderTitle.textContent = question.title;
        finderAnswerList.replaceChildren();
        question.choices.forEach((choice) => {
          const button = finderElement('button', 'finder-answer', choice.label);
          button.type = 'button';
          button.addEventListener('click', () => {
            history.push({ questionId: currentId, answer: choice.label, fallbackQueue: [...fallbackQueue], fallbackCandidates: [...fallbackCandidates] });
            if (choice.next) {
              currentId = String(choice.next);
              renderQuestion(true);
            } else {
              fallbackQueue = [];
              fallbackCandidates = [];
              renderHistory();
              showResult(choice.products || [], choice.reason);
            }
          });
          finderAnswerList.append(button);
        });
        if (question.allowUndecided) {
          const button = finderElement('button', 'finder-answer', finderText.undecided);
          button.type = 'button';
          button.addEventListener('click', () => {
            const candidates = candidateProducts(currentId);
            history.push({ questionId: currentId, answer: finderText.undecided, fallbackQueue: [...fallbackQueue], fallbackCandidates: [...fallbackCandidates] });
            if (!question.choices.every((choice) => !choice.next)) {
              fallbackCandidates = candidates;
              fallbackQueue = terminalQuestions(currentId);
            }
            fallbackQueue = fallbackQueue.filter((id) => id !== currentId);
            const next = fallbackQueue.shift();
            if (next) {
              currentId = next;
              renderQuestion(true);
              return;
            }
            const remaining = fallbackCandidates.length ? fallbackCandidates : candidates;
            fallbackQueue = [];
            fallbackCandidates = [];
            renderHistory();
            showResult(remaining, finderText.reason);
          });
          finderAnswerList.append(button);
        }
        if (focus) finderTitle.focus({ preventScroll: true });
      };
      const backFinder = () => {
        const previous = history.pop();
        if (!previous) return;
        fallbackQueue = previous.fallbackQueue;
        fallbackCandidates = previous.fallbackCandidates;
        currentId = previous.questionId;
        renderQuestion(true);
      };
      finderBack.addEventListener('click', backFinder);
      finderResultBack.addEventListener('click', backFinder);
      finderRestart.addEventListener('click', () => {
        currentId = rootId;
        history = [];
        fallbackQueue = [];
        fallbackCandidates = [];
        renderQuestion(true);
      });
      renderQuestion();
    };

    if (series[0]) activateSeries(series[0].key); else renderComparison();
    initializeFinder();
    loadModels();
  });
})();
